import jwtDecode from 'jwt-decode';
//
import axios from './axios';
import axiosV2 from './axiosV2';

// ----------------------------------------------------------------------

const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }

  // ----------------------------------------------------------------------

  // const decoded = jwtDecode(accessToken);
  // const currentTime = Date.now() / 1000;

  // return decoded.exp > currentTime;
  return true;
};

//  const handleTokenExpired = (exp) => {
//   let expiredTimer;

//   window.clearTimeout(expiredTimer);
//   const currentTime = Date.now();
//   const timeLeft = exp * 1000 - currentTime;
//   console.log(timeLeft);
//   expiredTimer = window.setTimeout(() => {
//     console.log('expired');
//     // You can do what ever you want here, like show a notification
//   }, timeLeft);
// };

// ----------------------------------------------------------------------

const setSession = (accessToken) => {
  if (accessToken) {
    localStorage.setItem('userClientTokenNew', accessToken);
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    axiosV2.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    // This function below will handle when token is expired
    // const { exp } = jwtDecode(accessToken);
    // handleTokenExpired(exp);
  } else {
    localStorage.removeItem('userClientTokenNew');
    delete axios.defaults.headers.common.Authorization;
    delete axiosV2.defaults.headers.common.Authorization;
  }
};

// const setClientMode = (isClient) => {
//   if (isClient) {
//     localStorage.setItem('isClient', isClient);
//   } else {
//     localStorage.removeItem('isClient');
//     delete axios.defaults.headers.common.Authorization;
//   }
// };

// const getClientMode = () => {
//   return localStorage.getItem('isClient');
// };

export { isValidToken, setSession };
